angular.module("UI8.components").component("inboxList", {
  template: `<div class="inbox">
      <div class="container">
        <div class="inbox__head">
          <h1 class="inbox__title">Inbox</h1>
        </div>

        <div class="inbox__list" ng-if="$ctrl.threads.length">
          <a class="inbox__row" ng-repeat="t in $ctrl.threads track by t._id" ng-href="/account/inbox/{{ t._id }}" ng-class="{unread: t.unread}">
            <span class="inbox__dot" ng-if="t.unread"></span>
            <div class="inbox__avatar">
              <img ng-if="t.other.avatar_url" ng-src="{{ t.other.avatar_url }}" alt="{{ t.other.name }}">
              <div class="inbox__initial" ng-if="!t.other.avatar_url">{{ t.other.name.charAt(0) }}</div>
            </div>
            <div class="inbox__body">
              <div class="inbox__name">
                {{ t.other.name }}
                <span class="hchip hchip--founding" ng-if="t.other.badge === 'founding'">Founding Member</span>
                <span class="hchip" ng-if="t.other.badge === 'verified'">Verified</span>
              </div>
              <div class="inbox__preview">{{ t.last_message }}</div>
            </div>
            <div class="inbox__time">{{ t.last_message_at | relativeDate }}</div>
          </a>
        </div>

        <div class="inbox__empty" ng-if="!$ctrl.threads.length && !$ctrl.loading">
          <p>No conversations yet.</p>
          <p class="inbox__hint">Inquiries you send, and inquiries clients send you, arrive here.</p>
        </div>

        <div class="inbox__foot" ng-if="$ctrl.mayHaveMore">
          <button class="btn btn--stroke" ng-if="!$ctrl.loading" ng-click="$ctrl.more()">Load more</button>
          <div class="loader loader--small" ng-if="$ctrl.loading"></div>
        </div>
      </div>
    </div>`,

  controller: function (HireService, $scope) {
    var ctrl = this;

    ctrl.threads = [];
    ctrl.page = 1;
    ctrl.loading = true;
    ctrl.mayHaveMore = false;

    function load() {
      HireService.threads(ctrl.page).then(function (res) {
        ctrl.loading = false;
        if (res && res.threads) {
          ctrl.threads = ctrl.threads.concat(res.threads);
          ctrl.mayHaveMore = res.threads.length === 20;
        }
        $scope.$applyAsync();
      });
    }

    ctrl.$onInit = load;

    ctrl.more = function () {
      ctrl.page++;
      ctrl.loading = true;
      load();
    };
  },
});
